import { useMemo, type FC } from 'react';

import { useFeature } from '@/features/feature-management/provider/useFeature';
import type { EntertainmentFeature } from '@/features/feature-management/types/entertainmentFeature';
import { FeaturesEnum } from '@/features/feature-management/types/features';
import { WebviewSection } from '@/features/start/components/region/WebviewSection';

export const SponsorSection: FC = () => {
  const { isFeatureEnabled, getFeature } = useFeature();

  const { enabled, featureValues } = useMemo<EntertainmentFeature>(
    () => getFeature(FeaturesEnum.Entertainment),
    [getFeature]
  );

  const sponsorUrl = useMemo(
    () => (enabled ? featureValues.startPageWebviewUrl : undefined),
    [enabled, featureValues.startPageWebviewUrl]
  );

  if (!isFeatureEnabled(FeaturesEnum.Entertainment)) return;
  if (sponsorUrl === undefined || sponsorUrl.length === 0) return;

  return <WebviewSection url={sponsorUrl} />;
};

SponsorSection.displayName = 'SponsorSection';
